<template lang="pug">
  .messagepage
    .right_col(role='main')
      .page-title
        .title_left
          h2 メッセージボックス
      // 検索ブロック
      #searchbox.x_panel
        .x_title
          h3 検索フォーム
          ul.nav.navbar-right.panel_toolbox
        .x_content
          .searchbox
            .row
              .col-xs-2
                h5.searchitem フリー検索
                input.custom_input.form-control.searchitem(type='text' name='free-text' v-model='free_text')
              .col-xs-3
                h5.searchitem 日付
                #sandbox-container
                  #datepicker.input-daterange.input-group
                    input.input-sm.form-control.search-date(type='text' name='start' v-model='s_date')
                    span.input-group-addon to
                    input.input-sm.form-control.search-date(type='text' name='end' v-model='e_date')
              .col-xs-7
                .searchitem.selectitems.status
                  h5 状況
                  p
                    label.h5.control-label
                      input.checkbox01-input(type='checkbox' name='status'
                      v-model='status' value='1')
                      span.checkbox01-parts.no-padding
                      span 未対応&nbsp;&nbsp;&nbsp;
                    label.h5.control-label
                      input.checkbox01-input(type='checkbox' name='status'
                      v-model='status' value='2')
                      span.checkbox01-parts.no-padding
                      span 対応中&nbsp;&nbsp;&nbsp;
                    label.h5.control-label
                      input.checkbox01-input(type='checkbox' name='status'
                      v-model='status' value='3')
                      span.checkbox01-parts.no-padding
                      span 対応済&nbsp;&nbsp;&nbsp;
                    label.h5.control-label.no-padding
                      input.checkbox01-input(type='checkbox' name='status'
                      v-model='status' value='90')
                      span.checkbox01-parts.no-padding
                      span 対応不要&nbsp;&nbsp;&nbsp;
                .searchitem.selectitems.charge
                  h5 担当者
                  select.searchselect.selectitems(name='staff' v-model='staff')
                    option(value='null') ---
                    option(v-for='member in members' v-bind:value='member.id') {{member.name}}
            .col-xs-12.buttons
              button.customsmallbutton.btn.btn-info.searchitem(type='button' name='clear' @click='clear') クリア
              button.customsmallbutton.btn.btn-success.searchitem(type='button' name='search' @click='search') 検&nbsp;索
      // 問い合わせ表示ブロック
      .x_panel
        .x_content.messageboxcontents
          button.customsmallbutton.allopenbutton.btn.btn-success(@click='allshow_hide') 全展開
          table.datatable.table.table-striped.table-bordered(cellspacing='0', width='100%')
            thead
              tr
                th.openclose
                  //開閉ボタン
                th.name 件名
                th.sender 送信元
                th.time 問合せ日時
                th.history 履歴
                th.states 状況
                th.charge 担当者
                th.tagtitle タグ
            // 問い合わせのデータ表を構築(message)
            .row(is='row' v-for='(row, index) in disp_inquirys' :data.sync='row' :members.sync='members' :tags.sync='tags' :id='row.id' :index='index')
            .sidebars(is='history')
          // pager
          nav#pager(aria-label='Page navigation' v-show='pagerdisp')
            ul.pagination
              li
                a(href='javascript:void(0)', aria-label='Previous' v-show='pager.prev' @click='prev')
                  span(aria-hidden='true') «
              li(v-for='(num, index) in pager.total_page')
                a(href='javascript:void(0)' @click='paging' :num='num') {{num}}
              li
                a(href='javascript:void(0)', aria-label='Next' v-show='pager.next' @click='next')
                  span(aria-hidden='true') »

</template>

<script>
import $ from 'jquery'
import _ from 'underscore'
import bus from '@/service/EventBus'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'
// component
import messageRow from '@/components/dashboard/message/Message'
import messageHistory from '@/components/dashboard/message/MessageHistory'

export default {
  name: 'dashborad',
  data () {
    let pager = new Pager(10)
    pager.init([])

    return {
      inquiryIds: [], // 最初に取得するinquiryのidのみの配列
      disp_inquirys: [],  // inquiryの実際の中身とかが入る配列
      members: [],
      tags: [], // オートコンプリート用タグ配列
      pager: pager,
      pagerdisp: false,
      free_text: '',
      s_date: null,
      e_date: null,
      status: ['1'],
      staff: ''
    }
  },
  mounted () {
    bus.$emit('select_menu', 'message')

    let self = this

    // bootstrap-datepicker
    $('#sandbox-container .input-daterange').datepicker({
      language: 'ja',
      orientation: 'bottom left'
    })
    // 他の要素をchangeすると消えるのでデータを明示的にセットする
    $('[name=start]').on('changeDate', function (e) {
      self._data.s_date = $('[name=start]').val()
    })
    $('[name=end]').on('changeDate', function (e) {
      self._data.e_date = $('[name=end]').val()
    })

    // 履歴表示ボタンが押されるまではdisplay:noneしておく
    $('.sidebar.right').css('display', 'none')

    // データ取得
    this.search()
  },
  methods: {
    search () {
      // 画面初期表示時、検索ボタン押下時
      this.bind()
    },
    clear () {
      // すべての検索プロパティを空にする
      this.free_text = ''
      this.s_date = null
      this.e_date = null
      this.status = []
      this.staff = ''
      this.bind()
    },
    // データバインド
    bind () {
      this.$nextTick(() => { Loader.show() })

      // 検索条件を取得
      let freeText = this.free_text
      let sDate = this.s_date
      let eDate = this.e_date
      let status = this.status
      let staff = this.staff

      let vue = this
      let axios = Request.instance(true)
      // ここでは検索結果に基づくinquiryのidとプルダウン用のメンバーのみ取得してくる
      axios.put('/message/' + this.$route.params.id,
        qs.stringify({
          free_text: JSON.stringify(freeText),
          s_date: JSON.stringify(sDate),
          e_date: JSON.stringify(eDate),
          status: JSON.stringify(status),
          staff: JSON.stringify(staff)
        })
      ).then((res) => {
        vue.inquiryIds = res.data.inquiryIds
        vue.members = res.data.members
        // pagerに格納(inquiryのidリスト)
        this.pager.init(vue.inquiryIds)
        // return すると次のthenへ遷移するらしい・・・
        return this.pager.disp_list
      }).then((dispList) => {
        this.getInquiryData(dispList)
      })
    },
    getInquiryData (inquiryIds) {
      // データが遅れて表示されるのが気になるので、表のデータ部をhideしておく
      $('.message-area').hide()
      // 検索結果でinquiryのidが存在すれば実データのリクエストをする
      if (inquiryIds.length > 0) {
        // 実際の問い合わせデータの中身とかはここでとる
        Request.create(true).put('/message/' + this.$route.params.id + '/datas', inquiryIds)
          .then((res) => {
            // pager見せる
            this.pagerdisp = true
            this.disp_inquirys = res.data.inquirys
            for (let key in this.disp_inquirys) {
              for (let key2 in this.disp_inquirys[key]) {
                if (key2 === 'tags') {
                  this.disp_inquirys[key].strTag = this.disp_inquirys[key].tags.join(',')
                }
              }
            }
            this.tags = res.data.tags
            // 前ページで読み込んでいたtagをremoveする
            $('[data-role=tagsinput]').tagsinput('removeAll')
            $('[data-role=tagsinput]').tagsinput()
            this.$nextTick(() => {
              // 全部終わったら表のデータ部を表示
              $('.message-area').show()
              Loader.hide()
            })
          }).catch((err) => {
            Message.error(err.response.data.message)
          })
      } else {
        // 検索結果でidがなければデータはない
        this.pager.init([])
        // pager 隠す
        this.pagerdisp = false
        this.disp_inquirys = []
        this.$nextTick(() => {
          Loader.hide()
        })
      }
    },
    // すべて展開
    allshow_hide () {
      let target = $('.hidden_row')
      // すべての行にアクションする
      $('.openclosebutton').addClass('clicked')
      target.show()
    },
    // pager関連
    prev: function (event) {
      this.pager.goPrev()
      this.getInquiryData(this.pager.disp_list)
      $('.openclosebutton').removeClass('clicked')
      $('.hidden_row').hide()
    },
    next: function (event) {
      this.pager.goNext()
      this.getInquiryData(this.pager.disp_list)
      $('.openclosebutton').removeClass('clicked')
      $('.hidden_row').hide()
    },
    paging: function (event) {
      let pageNum = event.target.innerHTML
      this.pager.goPage(pageNum)
      this.getInquiryData(this.pager.disp_list)
      $('.openclosebutton').removeClass('clicked')
      $('.hidden_row').hide()
    },
    // 配列化されているtagsをテーブルに表示するためにカンマ区切りの文字列に変換する
    showTags: function (id) {
      let tagStr = this._data.tags[id].join(',')
      return tagStr
    }
  },
  components: {
    row: messageRow,
    history: messageHistory
  }
}

// pager
function Pager (limit) {
  this.limit = limit

  this.from = ''
  this.to = ''
  this.total_count = ''

  this.current_page = ''
  this.total_page = ''

  this.orgList = []
  this.disp_list = []

  this.prev = false
  this.next = false
}
Pager.prototype = {
  goPrev: function () {
    this.current_page--
    this.paging()
  },
  goNext: function () {
    this.current_page++
    this.paging()
  },
  goPage: function (pageNum) {
    this.current_page = Number(pageNum)   // 数値に変換しておかないと、後の===判定で予期しない挙動が発生する
    this.paging()
  },
  init: function (orgList) {
    // 最大件数
    orgList = orgList || []
    this.total_count = orgList.length
    if (this.total_count === 0) {
      // 結果なしなら何もしない
      this.orgList.splice(0, this.orgList.length)
      this.disp_list.splice(0, this.disp_list.length)
      return
    }
    // 最大ページ数
    this.total_page = Math.ceil(this.total_count / this.limit)
    this.orgList = orgList
    // 検索時は必ず1
    this.current_page = 1

    this.paging()
  },
  paging: function () {
    // カレントページから参照範囲を求める
    var to = this.current_page * this.limit
    var from = to - this.limit

    // 参照範囲が最大件数を超えたら最大をtoにする
    if (this.total_count < to) {
      to = this.total_count
    }

    // 参照範囲のデータを切り替える
    this.disp_list = _.clone(this.orgList).splice(from, this.limit)

    this.from = from + 1 // +1標記
    this.to = to

    // ページコントロールの制御
    if (this.current_page === 1) {
      this.prev = false
    } else if (this.current_page > 1) {
      this.prev = true
    }
    if (this.current_page === this.total_page) {
      this.next = false
    } else if (this.current_page < this.total_page) {
      this.next = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.bootstrap-tagsinput
  width: 90%
  resize: vertical
.tag
  display: inline !important
  float: none !important
.tag:after
  border-left: none
#searchbox
  padding: 0px 25px 10px
  .x_title
    padding: -1px 5px 30px
    border-bottom: 1px solid #E6E9ED
    margin-bottom: 20px
    h4
      margin-bottom: 0
  #datepicker
    width: 180px
    .search-date
      width: 90px
  .x_content
    margin-top: -20px
    .customsmallbutton
      margin-top: -85px
  .searchitem
    display: inline-block
  .form-horizontal
    padding: 0
  .buttons
    text-align: center
    margin-bottom: 0
    .customsmallbutton
      margin-top: 0
      padding: 6px 10px
      font-size: 14px
  //- 検索BOXの状況の間隔
  .status
    margin-left: 15px
  @media (min-width: 1400px)
    .col-xs-3
      padding-left: 80px
    .custom_input
      width: 250px
    .charge
      padding-left: 30px
.datatable
  thead
    background-color: #EEE
  tbody > tr
    background-color: #FFF
  td.center
    text-align: center
  td
    word-break: break-all
  .openclose
    width: 3%
  .name
    width: 20%
  .sender
    width: 20%
  .time
    width: 10%
  .history
    width: 7%
  .states
    width: 10%
  .charge
    width: 10%
  .tagtitle
    width: 20%
  .row
    margin: 10px
  .hidden_row
    display: none
  textarea
    padding: 0
    width: 20%
  .taglabel
    vertical-align: top
  .messagedetail
    textarea
      resize: vertical
    .contens
      width: 100%
    .title
      width: 90%
      border-radius: 3px
    .remarks
      width: 90%
    .list-box
      display: table
    .data-caption
      width: 120px
    .data-value
      display: table-cell
      vartical-align: middle
  .selectitems
    margin-right: 30px
  label
    margin-right: 5px
  pre
    white-space: pre-wrap
.messageboxcontents
  .customsmallbutton
    margin-left: 5px
    padding: 6px 10px
    font-size: 14px
  .deletebutton
    float: right
.tdcenter
  text-align: center
#readingmessage
  color: #FFF
.minimize-btn
  color: #FFF
.commentsnote
  text-align: left
</style>




// WEBPACK FOOTER //
// Messages.vue?084c9b6a